import React, { useState } from "react";
import "./Settings.css";
const ClientDashboardSettings = () => {
  const [section, setSection] = useState(1);
  return (
    <div className="clientdashboard__settings_section">
      <div className="clientdashboard__settings_wrapper">
        <div className="clientdashboard__settings_banner">
          <button
            className={`clientdashboard__settings_bnrbtn ${
              section === 1 ? "clientdashboard__settings_bnrbtnactive" : ""
            }`}
            onClick={() => setSection(1)}
          >
            Edit Profile
          </button>
          <button
            className={`clientdashboard__settings_bnrbtn ${
              section === 2 ? "clientdashboard__settings_bnrbtnactive" : ""
            }`}
            onClick={() => setSection(2)}
          >
            Change Password
          </button>
        </div>
        {section === 1 && (
          <div className="clientdashboard__settings_innersection">
            <div className="clientdashboard__settings_inrsecheader">
              Edit Profile
            </div>
            <div className="clientdashboard__settings_inrsecbody">
              <div className="clientdashboard__settings_inrsecrow">
                <div className="clientdashboard__settings_inrseccolleft">
                  <label className="clientdashboard__settings_inputlbl">
                    Name
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__settings_inputfield"
                    placeholder="Saidul Islam"
                  />
                </div>
                <div className="clientdashboard__settings_inrseccol">
                  <label className="clientdashboard__settings_inputlbl">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__settings_inputfield"
                    placeholder="+91-123566543"
                  />
                </div>
              </div>
              <div className="clientdashboard__settings_inrsecrow">
                <div className="clientdashboard__settings_inrseccolleft">
                  <label className="clientdashboard__settings_inputlbl">
                    Email ID
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__settings_inputfield"
                    placeholder="Enter Email Address"
                  />
                </div>
                <div className="clientdashboard__settings_inrseccol"></div>
              </div>
            </div>
          </div>
        )}
        {section === 2 && (
          <div className="clientdashboard__settings_innersection">
            <div className="clientdashboard__settings_inrsecheader">
              Change Password
            </div>
            <div className="clientdashboard__settings_inrsecbody">
              <div className="clientdashboard__settings_inrsecrow">
                <div className="clientdashboard__settings_inrseccolleft">
                  <label className="clientdashboard__settings_inputlbl">
                    Email
                  </label>
                  <input
                    type="text"
                    className="clientdashboard__settings_inputfield"
                    placeholder="Saidul2k23@gmail.com"
                  />
                </div>
                <div className="clientdashboard__settings_inrseccol">
                  <label className="clientdashboard__settings_inputlbl">
                    Current Password
                  </label>
                  <input
                    type="password"
                    className="clientdashboard__settings_inputfield"
                    placeholder="Current Password"
                  />
                </div>
              </div>
              <div className="clientdashboard__settings_inrsecrow">
                <div className="clientdashboard__settings_inrseccolleft">
                  <label className="clientdashboard__settings_inputlbl">
                    New Password
                  </label>
                  <input
                    type="password"
                    className="clientdashboard__settings_inputfield"
                    placeholder="Enter New Password"
                  />
                </div>
                <div className="clientdashboard__settings_inrseccol">
                  <label className="clientdashboard__settings_inputlbl">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    className="clientdashboard__settings_inputfield"
                    placeholder="Enter Confirm Password"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {section === 1 && (
          <button className="clientdashboard__settings_btn">
            Save Changed
          </button>
        )}
        {section === 2 && (
          <button className="clientdashboard__settings_btn">Save</button>
        )}
      </div>
    </div>
  );
};

export default ClientDashboardSettings;
